module.exports = __webpack_public_path__ + "media/פח.44e00ad6.mp3";